import styled from "styled-components";

export const ActionSection = styled.div`
    margin-top: 15px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

export const DetailActionWrapper = styled.div`
    margin-top: 20px;
`;
